import classNames from "classnames"
import { IconButton } from "@mui/material"
import { AutoFixHigh } from "@mui/icons-material"
import OPTooltip from "components/material/tooltip"

import { BUTTON_PROPS } from "../shapes"

export default function AISummarizerButton({ title, handleClick, isLoading, isGenerated }) {
  return <OPTooltip title={title}>
    <IconButton color="primary" size="large" onClick={handleClick} className={classNames("generate-button", { loading: isLoading, loaded: isGenerated })}>
      <AutoFixHigh />
    </IconButton>
  </OPTooltip>
}

AISummarizerButton.propTypes = BUTTON_PROPS
